// import ResizableBox from "../ResizableBox";
import React, { useEffect, useState } from "react";
import Pe from "../../../images/dropableIcons/Pe.svg"
import Qe from "../../../images/dropableIcons/Qe.svg"
import Qt from "../../../images/dropableIcons/Qt.svg"
import Pb from "../../../images/dropableIcons/Pb.svg"
import Ps from "../../../images/dropableIcons/Ps.svg"
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles.js"
import { isMobile } from "react-device-detect";
import DraggableLabel from "../../DraggableLabel/index.js";
import DropableLabel from "../../DropableLabel/index.js";
import "animate.css/animate.css";

function Labels2(props) {
  const { step,
    draggedLabels,
    onDragUpdate,
    onDragEnd,
    setDraggableLabel,
    PeRef,
    QeRef,
    QtRef,
    PbRef,
    PsRef,
    inPe,
    inQe,
    inQt,
    inPb,
    inPs,
    peLabel,
    qeLabel,
    qtLabel,
    pbLabel,
    psLabel,
    submit,
    onDragOffUpdate,
    onDragOffEnd,
    screenSize,
    classes
  } = props;

  return (
    <>
      { step === 2 &&
        <div className={classes.labelContainer}>
          <h3 className={classes.dragText} >Drag the following labels to the graph:</h3>
          <div className={classes.optionContainer}>
            <h3 className={classes.optiontext}>Price at original equilibrium</h3>
            {!draggedLabels.includes("Pe") &&
              <DraggableLabel
                image={Pe}
                onDragUpdate={onDragUpdate}
                onDragStart={() => console.log("started")}
                onDragEnd={onDragEnd}
                setDraggableLabel={setDraggableLabel}
                label={"Pe"}
                displayLabel={"P<sub>e</sub>"}
              />
            }
          </div>
          <div className={classes.optionContainer}>
            <h3 className={classes.optiontext}>Quantity at original equilibrium</h3>
            {!draggedLabels.includes("Qe") &&
                <DraggableLabel
                  image={Qe}
                  onDragUpdate={onDragUpdate}
                  onDragStart={() => console.log("started")}
                  onDragEnd={onDragEnd}
                  left={"0%"}
                  setDraggableLabel={setDraggableLabel}
                  label={"Qe"}
                  displayLabel={"Q<sub>e</sub>"}
                />
              }
          </div>

          <div className={classes.optionContainer}>
            <h3 className={classes.optiontext}>Quantity after tax</h3>
            {!draggedLabels.includes("Qt") &&
              <DraggableLabel
                image={Qt}
                onDragUpdate={onDragUpdate}
                onDragStart={() => console.log("started")}
                onDragEnd={onDragEnd}
                setDraggableLabel={setDraggableLabel}
                label={"Qt"}
                displayLabel={"Q<sub>t</sub>"}
              />
            }
          </div>

          <div className={classes.optionContainer}>
            <h3 className={classes.optiontext}>Price buyers pay after tax</h3>
            {!draggedLabels.includes("Pb") &&
              <DraggableLabel
                image={Pb}
                onDragUpdate={onDragUpdate}
                onDragStart={() => console.log("started")}
                onDragEnd={onDragEnd}
                setDraggableLabel={setDraggableLabel}
                label={"Pb"}
                displayLabel={"P<sub>b</sub>"}
              />
            }
          </div>

          <div className={classes.optionContainer}>
            <h3 className={classes.optiontext}>Price sellers receive after tax</h3>
            {!draggedLabels.includes("Ps") &&
              <DraggableLabel
                image={Ps}
                onDragUpdate={onDragUpdate}
                onDragStart={() => console.log("started")}
                onDragEnd={onDragEnd}
                setDraggableLabel={setDraggableLabel}
                label={"Ps"}
                displayLabel={"P<sub>s</sub>"}
              />
            }
          </div>
        </div>
      }
      { step === 2 &&
      <div className={classes.dropableLabelsContainer}>
        {/* targetY = 80 */}
        <DropableLabel
          aref={PbRef}
          inAnswer={inPb}
          height={40}
          isRight={true}
          // right={'46%'}
          onDragOffUpdate={onDragOffUpdate}
          onDragStart={() => console.log("started")}
          onDragOffEnd={onDragOffEnd}
          name={"Pb"}
          marginTop={isMobile ? 48 : 80}
          rotate={"rotate(0deg)"}
          label={pbLabel}
          isSubmitted={submit}
          isCorrectLabel={pbLabel==="Pb"}
        />
        {/* targetY = 174 */}
          <DropableLabel
          aref={PeRef}
          inAnswer={inPe}
          isRight={true}
          // right={"46%"}
          onDragOffUpdate={onDragOffUpdate}
          onDragStart={() => console.log("started")}
          onDragOffEnd={onDragOffEnd}
          name={"Pe"}
          marginTop={ isMobile ? 48 : 100 }
          rotate={"rotate(0deg)"}
          label={peLabel}
          isSubmitted={submit}
          isCorrectLabel={peLabel==="Pe"}
        />

        {/* targetY = 268 */}
        <DropableLabel
          aref={PsRef}
          inAnswer={inPs}
          isRight={true}
          // right={'46%'}
          onDragOffUpdate={onDragOffUpdate}
          onDragStart={() => console.log("started")}
          onDragOffEnd={onDragOffEnd}
          name={"Ps"}
          marginTop={isMobile ? 8 : 30}
          rotate={"rotate(0deg)"}
          label={psLabel}
          isSubmitted={submit}
          isCorrectLabel={psLabel==="Ps"}
        />

        <div
        style={{  

          width: isMobile ? 80 : 130,
          marginRight: isMobile ? -148 : -236,
          display: "flex",
          height: 60,
          justifyContent: "space-between",
          alignItems: "center",
          // background: "red",
          // position: "absolute",
          marginTop: isMobile ? 26 : 60,
        }}
        >

            {/* targetY = 312 */}
            <DropableLabel
            aref={QtRef}
            inAnswer={inQt}
            isRight={true}
            // right={ -176 }
            // marginTop={ 105 }
            onDragOffUpdate={onDragOffUpdate}
            onDragStart={() => console.log("started")}
            onDragOffEnd={onDragOffEnd}
            name={"Qt"}
            rotate={"rotate(0deg)"}
            label={qtLabel}
            isSubmitted={submit}
            isCorrectLabel={qtLabel==="Qt"}
          />
{/* targetY = 356 */}
          <DropableLabel
            aref={QeRef}
            inAnswer={inQe}
            isRight={true}
            // right={ "-40%" }
            // marginTop={ -44 }
            onDragOffUpdate={onDragOffUpdate}
            onDragStart={() => console.log("started")}
            onDragOffEnd={onDragOffEnd}
            name={"Qe"}
            rotate={"rotate(0deg)"}
            label={qeLabel}
            isSubmitted={submit}
            isCorrectLabel={qeLabel==="Qe"}
          />
        </div>
      </div>
      }
    </>
  )
}
export default  withStyles(styles)(Labels2);